import React from 'react'

const ReportsFluidsIcon = (
  <>
    <path
      d="M7.796 0.957969C7.63017 0.800469 7.37017 0.800469 7.20434 0.957969C6.92725 1.23547 0.416847 7.84547 0.416847 12.083C0.37893 15.9571 3.48892 19.1284 7.36267 19.1663C7.4085 19.1667 7.45433 19.1667 7.50017 19.1663C11.3743 19.2042 14.5456 16.0942 14.5835 12.2205C14.5839 12.1746 14.5839 12.1288 14.5835 12.083C14.5835 7.84547 8.07308 1.23547 7.796 0.957969Z"
      fill="url(#paint0_linear_2457_7805)"
    />
    <path
      d="M7.5 15.833C6.05042 15.833 3.75 14.8151 3.75 12.083C3.78875 11.5614 3.93042 11.0526 4.16667 10.5859C4.58333 13.4114 6.5625 15.078 9.22583 15.4164C8.68875 15.6818 8.09917 15.8243 7.5 15.833Z"
      fill="url(#paint1_linear_2457_7805)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2457_7805"
        x1="7.50017"
        y1="0.839844"
        x2="7.50017"
        y2="19.1666"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DEF2FD" />
        <stop offset="1" stopColor="#9ED9FA" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2457_7805"
        x1="6.48792"
        y1="10.5859"
        x2="6.48792"
        y2="15.833"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#60BEF6" />
        <stop offset="1" stopColor="#29A0EA" />
      </linearGradient>
    </defs>
  </>
)

export default ReportsFluidsIcon
